import { styled } from '@mui/material/styles';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';

const StyledButton = styled(Button)(({ theme }) => ({
  width: '100%',
  display: 'flex',
  borderRadius: '0px',
  justifyContent: 'flex-start',
  padding: '.5rem',
  color: theme.palette.text.primary,
  '&.active': {
    background: theme.palette.grey[300],
  },
}));

export const SidebarButton = ({
  video,
  index,
  currentVideo,
  videosCompleted,
  handleSidebarNav,
  productTrainingStatus,
}) => {
  return (
    <StyledButton
      className={currentVideo.ID === video.ID ? 'active' : ''}
      disabled={productTrainingStatus === true || videosCompleted.includes(video.ID ? false : true)}
      key={video.ID}
      onClick={() => handleSidebarNav(video.ID, index)}
    >
      Module {index + 1}
      <Box sx={{ paddingLeft: '.5rem' }}>
        {productTrainingStatus.trainingComplete || videosCompleted.includes(video.ID) ? (
          <CheckCircleOutlineIcon fontSize="small" sx={{ color: 'success.main' }} />
        ) : null}
      </Box>
    </StyledButton>
  );
};
